import { Controller } from "@hotwired/stimulus"
import {translate as t} from 'common/i18n'
import $ from 'jquery'
import Dialog from 'common/dashboard/dashboard/dialog'

export default class extends Controller {
  static targets = [
    'dialog',
    'request',
    'response',
    'codes',
    'closeBtn',
    'cancelBtn',
    'generateBtn',
    'authForm'
  ]
  static values = {
    backupCodesUrl: String,
    replace: Boolean
  }

  connect() {
    // ask the parent to reload the page
    $(this.dialogTarget).on('closed.zf.reveal', ()=> this.dispatch("reload", {prefix: false}))
    this.#show(this.requestTarget)
    this.#hide(this.responseTarget)
    this.#hide(this.closeBtnTarget)
    this.#show(this.cancelBtnTarget)
    this.#show(this.generateBtnTarget)
  }

  async start() {
    if(this.replaceValue) {
      let confirm = {
        title: t('users.generate_tfa_backup_codes.title'),
        message: t('users.generate_tfa_backup_codes.warning')
      }
      if(await Dialog.confirm(confirm)) {
        $(this.dialogTarget).foundation('open')
        this.perform()
      }
    } else {
      $(this.dialogTarget).foundation('open')
      this.perform()
    }
  }

  async perform() {
    let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    
    let headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken,
    }
    
    headers = Object.assign(headers, await this.#authController.authHeaders())
    
    this.#beginLoad()
    this.authFormTarget.dataset['users-AuthenticationFormErrorsValue'] = JSON.stringify([])

    const req = new Request(this.backupCodesUrlValue)
    const params = {
      method: 'PATCH',
      headers: headers,
      'body': JSON.stringify({})
    }
    let response = await fetch(req, params)

    if(response.status < 300) {
      let data = await response.json()

      this.#hide(this.requestTarget)
      this.#show(this.responseTarget)
      let html = data.codes.map((c)=> `<div class="cell medium-6">${c}</div>`)
      this.codesTarget.innerHTML = html.join('');
      this.#hide(this.cancelBtnTarget)
      this.#hide(this.generateBtnTarget)
      this.#show(this.closeBtnTarget)
    } else if(response.status === 403) {
      const {error, messages, credentials} = await response.json()
      this.authFormTarget.dataset['users-AuthenticationFormMethodsValue'] = JSON.stringify(credentials)
      this.authFormTarget.dataset['users-AuthenticationFormErrorsValue'] = JSON.stringify(messages)
    }

    this.#endLoad()
  }

  get #authController() {
    return this.application.getControllerForElementAndIdentifier(this.authFormTarget, 'users--authentication-form')
  }

  #beginLoad() {
    if(!this._mask) {
      this._mask = document.createElement('div')
      this._mask.classList.add('loading-mask')
      this._mask.innerHTML = '<i class="fas fa-spinner fa-3x fa-spin"></i>'
      this.dialogTarget.appendChild(this._mask)
    }
  }

  #endLoad() {
    if(this._mask) {
      this._mask.remove()
      this._mask = null
    }
  }

  #hide(element) {
    element.classList.add('hide')
  }

  #show(element) {
    element.classList.remove('hide')
  }
}
